// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RadioStyle } from "@insite/mobius/Radio";
import { TypographyProps } from "@insite/mobius/Typography";
import { getNotifyStyle } from "@west/App/Components/Notify";
import { accountSettingsDefaultBillingShippingStyles } from "@west/Overrides/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping";
import { mergeWithCss } from "@west/XDL/Utilities";
import { css } from "styled-components";

const commonTitleStyle: TypographyProps = {
    variant: "h2",
    as: "h2",
    size: 20,
    css: css`
        &&& {
            line-height: 26px;
        }
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultBillingShippingTitle = {
    ...commonTitleStyle,
};

accountSettingsDefaultBillingShippingStyles.headingText = {
    ...mergeWithCss(commonTitleStyle, {
        css: css`
            margin-block: 4px 0;
        `,
    }),
};

accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGridItem = {
    width: 12,
    css: css`
        padding: 5px 10px;
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultBillingAddress =
    accountSettingsDefaultBillingShippingStyles.defaultShippingAddress = {
        headingText: {
            ...commonTitleStyle,
        },
        editLink: {
            css: css`
                margin-left: 10px;
                margin-top: 7px;
            `,
        },
    };

accountSettingsDefaultBillingShippingStyles.customerSelectorGridContainer = {
    css: css`
        margin: 15px;
    `,
    gap: 15,
};

accountSettingsDefaultBillingShippingStyles.defaultFulfillmentMethodRadioGroup = {
    css: css`
        display: inline-block;
        width: 100%;
        flex-direction: row;
        & > ${RadioStyle} {
            margin-right: 20px;
            display: inline-flex;
            input[type="radio"] {
                margin: 0;
            }
        }
        ${RadioStyle} + ${RadioStyle} {
            margin-top: 0;
        }
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultFulfillmentMethodRadioGridItem = {
    width: 12,
    css: css`
        display: block;
    `,
};

accountSettingsDefaultBillingShippingStyles.customerSelectorGridItem = {
    width: 12,
};

accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGroup = {
    css: css`
        display: inline-block;
        width: 100%;
        flex-direction: row;
        & > div {
            margin-right: 20px;
            display: inline-flex;
        }
    `,
};

accountSettingsDefaultBillingShippingStyles.pickUpLocation = {
    gridContainer: { gap: 5 },
    headingGridItem: { width: 12 },
    headerText: {
        ...commonTitleStyle,
    },
    changeLink: {
        css: css`
            margin-left: 10px;
            margin-top: 5px;
        `,
    },
    warehouseGridItem: {
        width: 12,
    },
    warehouseAddress: {
        nameText: {
            as: "p",
        },
    },
};

accountSettingsDefaultBillingShippingStyles.notifyStyles = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin: 0;
            max-width: 500px;
        `,
    }),
};

accountSettingsDefaultBillingShippingStyles.warehouseAddressWrapper = {
    width: 12,
};
